import { Injectable } from '@angular/core';
import { CompanyEmployeeWithSubsidyAmount } from '@app/@graphql';
import { Observable, of } from 'rxjs';
import { CompanyRestaurantsData, CompanyRestaurantsTableData } from '../data/company-restaurants-data';
import { EmployeesData } from '../data/employees-data'

@Injectable()
export class CompanyRestaurantsService extends CompanyRestaurantsData
{
    allRestaurants: CompanyRestaurantsTableData[] = [
        {
            id: 1,
            name: 'Test Restaurant 1',
            menuItemsCount: 24,
            thisMonthAmount: 10560,
            thisMonthOrdersCount: 1000,
            thisMonthPercentage: 56
        },
        {
            id: 2,
            name: 'Test Restaurant 2',
            menuItemsCount: 15,
            thisMonthAmount: 6300,
            thisMonthOrdersCount: 450,
            thisMonthPercentage: 30
        },
        {
            id: 3,
            name: 'Test Restaurant 3',
            menuItemsCount: 18,
            thisMonthAmount: 3020,
            thisMonthOrdersCount: 232,
            thisMonthPercentage: 14
        }
    ];

    getCompanyRestaurantsTableData(): Observable<CompanyRestaurantsTableData[]>{
        return of(this.allRestaurants);
    }

    
}